import {
  AttendanceStatusType,
  ISelectOption,
  SelectionStatusType,
} from 'types';

export const ATTENDANCE_OPTIONS: ISelectOption<AttendanceStatusType>[] = [
  { name: '출석', value: 'PRESENT' },
  { name: '지각', value: 'LATE' },
  { name: '결석', value: 'ABSENT' },
  { name: '취소', value: 'CANCEL' },
  { name: '미정', value: 'UNDETERMINED' },
];

export const SELECTION_OPTIONS: ISelectOption<SelectionStatusType>[] = [
  { name: '신청 완료', value: 'APPLIED' },
  { name: '참여 확정', value: 'SELECTED' },
  { name: '미선정', value: 'NOT_SELECTED' },
];

/** 다중 선택값 → 쿼리 파라미터. 미선택·전체 선택이면 필터 없음. */
export const toStatusParam = <T extends string>(
  checkedValues: T[],
  total: number,
): string | undefined =>
  checkedValues.length === 0 || checkedValues.length === total
    ? undefined
    : checkedValues.join(',');
